import { Component, Input } from '@angular/core';
import { ViewComponent } from './view/view.component';
import { NgIf } from '@angular/common';
import { SelectionComponent } from './selection/selection.component';

@Component({
    selector: 'app-change-report',
    templateUrl: './change-report.component.html',
    styleUrls: ['./change-report.component.scss'],
    standalone: true,
    imports: [SelectionComponent, NgIf, ViewComponent]
})
export class ChangeReportComponent {

  @Input() FeatureLayer: any;
  @Input() Graphic: any;

  jobId : number

  selectJob(event){
    this.jobId = event;
  }
}
